import React, { createContext, useContext, useState } from "react";

export const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const TRANSLATIONS = {
  en: {
    code: "en", label: "EN",
    hello: "Hello,", member: "Member",
    home: "Home", knowledge: "Knowledge", polls: "Polls",
    programs: "Programs", profile: "Profile",
    memberStatus: "MEMBER STATUS", active: "✨ Active",
    members: "Members", activePolls: "Active Polls",
    announcements: "📢 Announcements",
    futurePlans: "🎯 Future Plans",
    logout: "Logout", admin: "Admin",
    plan1: "2025: Scholarship for 500 children",
    plan2: "2026: Digital library launch",
    plan3: "2027: Expansion to 10 states",
    knowledgeTitle: "Knowledge Hub",
    knowledgeSubtitle: "Select a category and expand your knowledge",
    readMore: "Read More →",
    chips: ["History", "Social Life", "Politics", "GK", "Science", "Economy", "Culture", "Sports"],
    articles: {
      History: [
        { title: "India's Freedom Struggle", desc: "From 1857 to 1947 — the journey to independence", read: "3 min" },
        { title: "Maratha Empire", desc: "Chhatrapati Shivaji Maharaj and his legacy", read: "5 min" },
      ],
      Politics: [
        { title: "Panchayati Raj System", desc: "From Gram Sabha to Zila Parishad", read: "4 min" },
        { title: "Election Process in India", desc: "From EVM to counting day", read: "3 min" },
      ],
      GK: [
        { title: "National Symbols of India", desc: "National bird, animal, flower and more", read: "2 min" },
        { title: "Seven Wonders of the World", desc: "New and old wonders explained", read: "4 min" },
      ],
      "Social Life": [
        { title: "Rural Society Structure", desc: "From village to city — changing dynamics", read: "5 min" },
        { title: "Women Empowerment", desc: "Changing role of women in society", read: "4 min" },
      ],
      Science: [
        { title: "ISRO's Achievements", desc: "Chandrayaan, Mangalyaan and beyond", read: "4 min" },
        { title: "Climate Change & India", desc: "Impact and what we can do", read: "3 min" },
      ],
      Economy: [
        { title: "GST Explained Simply", desc: "What is GST and how it affects you", read: "3 min" },
        { title: "Digital India Initiative", desc: "UPI, JAM trinity and financial inclusion", read: "4 min" },
      ],
      Culture: [
        { title: "Festivals of Maharashtra", desc: "Ganesh Chaturthi, Gudhi Padwa and more", read: "3 min" },
        { title: "Classical Dance Forms", desc: "Bharatanatyam, Kathak and others", read: "4 min" },
      ],
      Sports: [
        { title: "India at Olympics", desc: "Historic medals and proud moments", read: "3 min" },
        { title: "Rise of Indian Cricket", desc: "From 1983 to 2024 World Cup", read: "5 min" },
      ],
    },
  },

  hi: {
    code: "hi", label: "HI",
    hello: "नमस्ते,", member: "सदस्य",
    home: "होम", knowledge: "ज्ञान", polls: "मतदान",
    programs: "कार्यक्रम", profile: "प्रोफ़ाइल",
    memberStatus: "सदस्यता स्थिति", active: "✨ सक्रिय",
    members: "सदस्य", activePolls: "सक्रिय मतदान",
    announcements: "📢 सूचनाएं",
    futurePlans: "🎯 भविष्य की योजनाएं",
    logout: "लॉगआउट", admin: "एडमिन",
    plan1: "2025: 500 बच्चों को छात्रवृत्ति",
    plan2: "2026: डिजिटल पुस्तकालय शुरू",
    plan3: "2027: 10 राज्यों में विस्तार",
    knowledgeTitle: "ज्ञान केंद्र",
    knowledgeSubtitle: "श्रेणी चुनें और अपना ज्ञान बढ़ाएं",
    readMore: "और पढ़ें →",
    chips: ["इतिहास", "सामाजिक जीवन", "राजनीति", "सामान्य ज्ञान", "विज्ञान", "अर्थव्यवस्था", "संस्कृति", "खेल"],
    articles: {
      "इतिहास": [
        { title: "भारत का स्वतंत्रता संग्राम", desc: "1857 से 1947 तक — स्वतंत्रता की यात्रा", read: "3 मिनट" },
        { title: "मराठा साम्राज्य", desc: "छत्रपति शिवाजी महाराज और उनकी विरासत", read: "5 मिनट" },
      ],
      "राजनीति": [
        { title: "पंचायती राज व्यवस्था", desc: "ग्राम सभा से जिला परिषद तक", read: "4 मिनट" },
        { title: "भारत में चुनाव प्रक्रिया", desc: "EVM से मतगणना दिवस तक", read: "3 मिनट" },
      ],
      "सामान्य ज्ञान": [
        { title: "भारत के राष्ट्रीय प्रतीक", desc: "राष्ट्रीय पक्षी, पशु, फूल और अधिक", read: "2 मिनट" },
        { title: "विश्व के सात अजूबे", desc: "नए और पुराने अजूबों की जानकारी", read: "4 मिनट" },
      ],
      "सामाजिक जीवन": [
        { title: "ग्रामीण समाज संरचना", desc: "गांव से शहर — बदलती गतिशीलता", read: "5 मिनट" },
        { title: "महिला सशक्तिकरण", desc: "समाज में महिलाओं की बदलती भूमिका", read: "4 मिनट" },
      ],
      "विज्ञान": [
        { title: "ISRO की उपलब्धियां", desc: "चंद्रयान, मंगलयान और उससे आगे", read: "4 मिनट" },
        { title: "जलवायु परिवर्तन और भारत", desc: "प्रभाव और हम क्या कर सकते हैं", read: "3 मिनट" },
      ],
      "अर्थव्यवस्था": [
        { title: "GST सरल भाषा में", desc: "GST क्या है और यह आपको कैसे प्रभावित करता है", read: "3 मिनट" },
        { title: "डिजिटल इंडिया पहल", desc: "UPI, JAM त्रिकोण और वित्तीय समावेशन", read: "4 मिनट" },
      ],
      "संस्कृति": [
        { title: "महाराष्ट्र के त्योहार", desc: "गणेश चतुर्थी, गुड़ी पड़वा और अधिक", read: "3 मिनट" },
        { title: "शास्त्रीय नृत्य रूप", desc: "भरतनाट्यम, कथक और अन्य", read: "4 मिनट" },
      ],
      "खेल": [
        { title: "ओलंपिक में भारत", desc: "ऐतिहासिक पदक और गर्व के पल", read: "3 मिनट" },
        { title: "भारतीय क्रिकेट का उदय", desc: "1983 से 2024 विश्व कप तक", read: "5 मिनट" },
      ],
    },
  },

  mr: {
    code: "mr", label: "MR",
    hello: "नमस्कार,", member: "सदस्य",
    home: "मुखपृष्ठ", knowledge: "ज्ञान", polls: "मतदान",
    programs: "कार्यक्रम", profile: "प्रोफाइल",
    memberStatus: "सदस्यत्व स्थिती", active: "✨ सक्रिय",
    members: "सदस्य", activePolls: "सक्रिय मतदान",
    announcements: "📢 घोषणा",
    futurePlans: "🎯 भविष्यातील योजना",
    logout: "लॉगआउट", admin: "अॅडमिन",
    plan1: "2025: 500 मुलांना शिष्यवृत्ती",
    plan2: "2026: डिजिटल ग्रंथालय सुरू",
    plan3: "2027: 10 राज्यांमध्ये विस्तार",
    knowledgeTitle: "ज्ञान केंद्र",
    knowledgeSubtitle: "श्रेणी निवडा आणि ज्ञान वाढवा",
    readMore: "अधिक वाचा →",
    chips: ["इतिहास", "सामाजिक जीवन", "राजकारण", "सामान्य ज्ञान", "विज्ञान", "अर्थव्यवस्था", "संस्कृती", "क्रीडा"],
    articles: {
      "इतिहास": [
        { title: "भारताचा स्वातंत्र्य संग्राम", desc: "1857 ते 1947 — स्वातंत्र्याची वाटचाल", read: "3 मिनिटे" },
        { title: "मराठा साम्राज्य", desc: "छत्रपती शिवाजी महाराज आणि त्यांचा वारसा", read: "5 मिनिटे" },
      ],
      "राजकारण": [
        { title: "पंचायती राज व्यवस्था", desc: "ग्रामसभेपासून जिल्हा परिषदेपर्यंत", read: "4 मिनिटे" },
        { title: "भारतातील निवडणूक प्रक्रिया", desc: "EVM पासून मतमोजणीपर्यंत", read: "3 मिनिटे" },
      ],
      "सामान्य ज्ञान": [
        { title: "भारताची राष्ट्रीय चिन्हे", desc: "राष्ट्रीय पक्षी, प्राणी, फूल आणि बरेच काही", read: "2 मिनिटे" },
        { title: "जगातील सात आश्चर्ये", desc: "नवीन आणि जुन्या आश्चर्यांची माहिती", read: "4 मिनिटे" },
      ],
      "सामाजिक जीवन": [
        { title: "ग्रामीण समाज रचना", desc: "खेड्यापासून शहरापर्यंत — बदलती गतिशीलता", read: "5 मिनिटे" },
        { title: "महिला सशक्तीकरण", desc: "समाजातील महिलांची बदलती भूमिका", read: "4 मिनिटे" },
      ],
      "विज्ञान": [
        { title: "ISRO ची कामगिरी", desc: "चांद्रयान, मंगळयान आणि त्यापुढे", read: "4 मिनिटे" },
        { title: "हवामान बदल आणि भारत", desc: "परिणाम आणि आपण काय करू शकतो", read: "3 मिनिटे" },
      ],
      "अर्थव्यवस्था": [
        { title: "GST सोप्या भाषेत", desc: "GST म्हणजे काय आणि ते तुम्हाला कसे प्रभावित करते", read: "3 मिनिटे" },
        { title: "डिजिटल इंडिया उपक्रम", desc: "UPI, JAM त्रिकोण आणि आर्थिक समावेश", read: "4 मिनिटे" },
      ],
      "संस्कृती": [
        { title: "महाराष्ट्राचे सण", desc: "गणेश चतुर्थी, गुढी पाडवा आणि बरेच काही", read: "3 मिनिटे" },
        { title: "शास्त्रीय नृत्यप्रकार", desc: "भरतनाट्यम, कथक आणि इतर", read: "4 मिनिटे" },
      ],
      "क्रीडा": [
        { title: "ऑलिम्पिकमध्ये भारत", desc: "ऐतिहासिक पदके आणि अभिमानाचे क्षण", read: "3 मिनिटे" },
        { title: "भारतीय क्रिकेटचा उदय", desc: "1983 ते 2024 विश्वचषकापर्यंत", read: "5 मिनिटे" },
      ],
    },
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  const t = TRANSLATIONS[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}